<template>
  <div class="base-header">
    <div>
      <div class="title">
        <a :href="$i18n.t('website')" target="_blank">
          <img
            v-if="lang !== 'zh'"
            src="../../deps/public/solplanet-logo.png"
            height="40"
            alt=""
          />
          <img
            v-else
            src="../../deps/public/solplanet-logo1.png"
            height="40"
            alt=""
          />
        </a>
        <i
          :class="showmenu ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
          @click="showMenu"
        ></i>
        <el-dropdown style="float:right;">
          <div class="el-dropdown-link">
            <template v-for="m in dropdown">
              <a
                :key="m.key"
                href="javascript:;"
                :class="{ actived: lang == m.key }"
                v-if="lang == m.key"
                >{{ $i18n.t('language') }}</a
              >
            </template>
            <svg
              class="icon-orange"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1358"
            >
              <path
                d="M512 85.504c-0.128 0-0.224 0-0.352 0-0.064 0-0.096 0-0.16 0-0.16 0-0.32 0.032-0.512 0.032-235.104 0.544-425.472 191.264-425.472 426.464 0 235.136 190.368 425.888 425.472 426.464 0.16 0 0.32 0.032 0.512 0.032 0.064 0 0.128 0 0.16 0 0.128 0 0.256 0 0.352 0 235.52 0 426.496-190.976 426.496-426.496s-190.976-426.496-426.496-426.496zM529.056 340.736c45.216-1.248 89.216-7.2 131.584-17.536 12.768 50.272 20.704 108.224 21.952 171.744l-153.536 0 0-154.208zM529.056 306.624l0-184.288c45.984 12.736 92.576 74.048 122.272 168.064-39.392 9.504-80.288 15.04-122.272 16.224zM494.944 121.92l0 184.704c-42.336-1.184-83.552-6.816-123.264-16.48 29.952-94.592 76.96-156.128 123.264-168.192zM494.944 340.704l0 154.24-154.592 0c1.248-63.616 9.184-121.632 21.984-171.936 42.688 10.432 87.04 16.48 132.608 17.696zM306.016 494.944l-185.952 0c3.776-87.712 36.448-168.064 88.736-231.712 37.984 20.928 78.272 38.048 120.512 50.848-13.792 54.4-22.048 115.744-23.296 180.864zM306.016 529.056c1.248 65.088 9.504 126.432 23.296 180.832-42.208 12.832-82.528 29.952-120.512 50.88-52.32-63.648-84.992-144-88.736-231.712l185.952 0zM340.352 529.056l154.592 0 0 154.048c-45.568 1.216-89.92 7.296-132.64 17.76-12.768-50.272-20.704-108.256-21.952-171.808zM494.944 717.184l0 184.896c-46.336-12.096-93.408-73.696-123.328-168.416 39.712-9.664 80.96-15.296 123.328-16.48zM529.056 901.696l0-184.48c42.016 1.216 82.912 6.752 122.304 16.256-29.696 94.112-76.288 155.52-122.304 168.224zM529.056 683.104l0-154.048 153.536 0c-1.248 63.456-9.152 121.312-21.888 171.552-42.4-10.336-86.4-16.32-131.616-17.536zM716.928 529.056l187.04 0c-3.776 87.712-36.416 168.032-88.736 231.68-38.304-21.056-78.944-38.304-121.504-51.168 13.76-54.336 21.984-115.552 23.232-180.48zM716.928 494.944c-1.248-65.056-9.504-126.272-23.264-180.672 42.56-12.864 83.168-30.08 121.44-51.136 52.352 63.648 85.056 144.032 88.832 231.808l-187.04 0zM791.616 237.088c-33.952 18.048-69.76 32.992-107.2 44.32-19.936-64.16-47.936-116.544-81.056-150.944 72.64 17.44 137.504 55.008 188.256 106.624zM419.296 130.784c-32.928 34.336-60.8 86.464-80.672 150.304-37.056-11.296-72.576-26.08-106.208-44 50.4-51.264 114.784-88.768 186.88-106.304zM232.288 786.784c33.664-17.952 69.216-32.768 106.304-44.064 19.872 63.904 47.744 116.128 80.704 150.464-72.16-17.568-136.576-55.072-187.008-106.432zM603.36 893.504c33.152-34.4 61.152-86.784 81.12-151.072 37.44 11.36 73.28 26.24 107.232 44.384-50.752 51.648-115.648 89.312-188.352 106.688z"
                p-id="1359"
              ></path>
            </svg>
          </div>
          <el-dropdown-menu slot="dropdown" class="header-drop">
            <el-dropdown-item
              v-for="m in dropdown"
              :key="m.value"
              @click.native="m.fn()"
              >{{ m.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <div class="logout" v-if="isLogin">
          <el-button @click="loginout">{{ $i18n.t('loginOut') }}</el-button>
          <img
            @click="$router.push({ name: 'Ordermanagement' })"
            src="../../deps/public/personal-red.png"
            alt=""
          />
        </div>
        <div class="logout" v-else>
          <el-button @click="$router.push({ name: 'login' })">{{
            $i18n.t('goLogin')
          }}</el-button>
          <img
            @click="$router.push({ name: 'login' })"
            src="../../deps/public/person-black.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="banner">
      <span
        class="phone-login"
        v-if="!isLogin"
        @click="$router.push({ name: 'login' })"
        >Log ln</span
      >
      <div style="margin-left:19%;padding-top:100px">
        <div style="text-align: left;">
          <p>
            <span
              style="width: 1006px;height: 114px;font-size: 48px;font-family: lineto-circular-pro-book, HelveticaNeue;color: #FFFFFF;line-height: 58px;"
            >
              {{ $i18n.t('banner1') }}</span
            >
          </p>
          <p>
            <span
              style="width: 1006px;height: 114px;font-size: 48px;font-family: lineto-circular-pro-book, HelveticaNeue;color: #FFFFFF;line-height: 58px;"
            >
              {{ $i18n.t('banner1_1') }}</span
            >
          </p>
          <p>
            <span
              style="width: 1006px;height: 114px;font-size: 48px;font-family: lineto-circular-pro-book, HelveticaNeue;color: #FFFFFF;line-height: 58px;"
            >
              {{ $i18n.t('banner2') }}</span
            >
          </p>
          <p style="margin-top: 30px;">
            <span
              style="width: 282px;height: 36px;font-size: 30px;font-family: lineto-circular-pro-book, HelveticaNeue;color: #FFFFFF;line-height: 37px;"
            >
              {{ $i18n.t('banner3') }}</span
            >
          </p>
        </div>
      </div>
    </div>
    <div class="links">
      <div class="w1200">
        <!-- <span>{{ $i18n.t('asw') }}</span> -->
        <div class="ul-btn">
          <el-button
            type="text"
            v-for="m in links"
            :key="m.value"
            @click="goRouter(m.name)"
            :class="{ actived: $route.name === m.name }"
            >{{ m.label }}</el-button
          >
        </div>
      </div>
    </div>
    <div class="phoneMenu" v-if="showmenu">
      <div v-for="m in phoneMenu" :key="m.label">
        <div class="tilte">
          {{ m.label }}
          <i
            @click="m.showChild = !m.showChild"
            :class="m.showChild ? 'el-icon-minus' : 'el-icon-plus'"
          ></i>
        </div>
        <div v-show="m.showChild" class="lists">
          <div v-for="n in m.children" :key="n.label" @click="goRouter(n.href)">
            {{ n.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { I18N_KEY } from '@/app/util'
// import { loginOut } from '@/deps/apis/login'
export default {
  computed: {
    isLogin() {
      return this.userData
    },
    links() {
      let link = [
        {
          name: 'WarrantySearch',
          label: this.$i18n.t('search')
        },
        {
          name: 'WarrantyExtenish',
          label: this.$i18n.t('extension')
        },
        {
          name: 'WarrantyActivation',
          label: this.$i18n.t('activation')
        }
      ]
      if (this.$route.path.indexOf('userSetting') >= 0) {
        link = [
          {
            name: 'Ordermanagement',
            label: this.$i18n.t('orderManagementMenu')
          },
          {
            name: 'Emailsetting',
            label: this.$i18n.t('changeEmailMenu')
          },
          {
            name: 'Passwordsetting',
            label: this.$i18n.t('changePasswordMenu')
          },
          {
            name: 'Accountsetting',
            label: this.$i18n.t('accountInfoMenu')
          }
        ]
      }
      return link
    }
  },
  data() {
    return {
      lang: 'en',
      userName: '',
      showmenu: false,
      userData: sessionStorage.getItem('userData'),
      dropdown: I18N_KEY.map(key => {
        let label = key === 'zh' ? this.$i18n.t('chinese') : key === 'en' ? `${this.$i18n.t('english')}(${this.$i18n.t('global')})` : this.$i18n.t(key)
        return {
          key: key,
          label: label,
          fn: () => {
            this.changeL(key)
          }
        }
      }),
      phoneMenu: [
        {
          label: 'Warranty',
          showChild: true,
          children: [
            {
              label: this.$i18n.t('search'),
              href: 'WarrantySearch'
            },
            {
              label: this.$i18n.t('extension'),
              href: 'WarrantyExtenish'
            },
            {
              label: this.$i18n.t('activation'),
              href: 'WarrantyActivation'
            }
          ]
        },
        {
          label: 'Personal Center',
          showChild: false,
          children: [
            {
              label: this.$i18n.t('changeEmailMenu'),
              href: 'Emailsetting'
            },
            {
              label: this.$i18n.t('password'),
              href: 'Passwordsetting'
            },
            {
              label: this.$i18n.t('accountInfo'),
              href: 'Accountsetting'
            },
            {
              label: this.$i18n.t('orderManagementMenu'),
              href: 'Ordermanagement'
            }
          ]
        }
      ]
    }
  },
  methods: {
    goRouter(href) {
      if (!window.isLogin) {
        this.$router.push({ name: 'login', query: { name: href } })
        return
      }
      this.showmenu = false
      document.querySelector('html').style = ''
      this.$router.push({ name: href })
    },
    showMenu() {
      if (this.showmenu) {
        document.querySelector('html').style = ''
        this.showmenu = false
      } else {
        document.querySelector('html').style = 'overflow:hidden'
        this.showmenu = true
      }
    },
    loginout() {
      sessionStorage.clear()
      window.isLogin = null
      // this.$router.push({ name: "login" });
      this.$message.success(this.$i18n.t('Logout'))
      this.userData = null
      this.$forceUpdate()
    },
    changeL(lang) {
      const prevLang = location.hash.split('/')[1]
      location.href = location.href.replace(prevLang, lang)
      setTimeout(() => {
        location.reload()
      })
    }
  },
  created() {
    document.title = this.$i18n.t('documentTitle')
    this.lang = location.hash.split('/')[1]
  },
  mounted() {
    if (!this.isLogin) {
      this.phoneMenu.splice(1, 1)
    }
  }
}
</script>
<style lang="stylus">
.isPC {
  .phone-login {
    display: none;
  }

  .w1200 .page-transition {
    min-height: 500px;
  }
  .header-drop {
    top: 80px !important;
  }
}

.base-header {
  width: 100%;
  background: #fff;

  .title {
    height: 90px;
    line-height: 90px;
    padding-left: 60px;
    padding-right: 30px;

    .icon-orange {
      position: relative;
      top: 6px;
      width: 26px;
    }

    & > i {
      display: none;
    }

    img {
      margin-top: 25px;
      max-width: 239px;
      max-height: 64px;
    }

    a {
      margin-left: 15px;
      font-size: 18px;
      color: #333;
    }

    .logout {
      float: right;
      margin-right: 15px;
      border-right: 1px solid #D8D8D8;

      .el-button {
        background: linear-gradient(270deg, #ab499e 0%, #ff4f4f 100%);
        color: #fff;
        height: 30px;
        line-height: 30px;
        border-radius: 30px;
        padding: 0;
        min-width: 120px;
      }

      img {
        margin: 0 32px;
        position: relative;
        top: 10px;
        cursor: pointer;
      }
    }

    .actived {
      color: #3E3E3E;
      font-weight: bold;
    }
  }

  .banner {
    height: 385px;
    background: url('../../deps/public/base-banner.png') no-repeat center center;
    background-size: cover;
  }

  .links {
    border-bottom: 1px solid #dadada;
    box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);

    .w1200 {
      overflow: hidden;
      line-height: 36px;
      padding: 0;

      & > span {
        font-size: 24px;
        font-weight: normal;
        color: rgba(153, 153, 153, 1);
      }
    }

    .ul-btn {
      float: right;
      width: 60%;

      .el-button {
        color: #333333;
        font-size: 18px;
        margin-right: 4%;
        padding: 2%;
        font-weight: bold;
        border: 0;
        margin-left: 0;

        &:hover {
          color: #FF4F4F;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .actived {
        color: #FF4F4F;
        position: relative;

        &:after {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          height: 6px;
          width: 85%;
          left: 7%;
          background: linear-gradient(270deg, #AB499E 0%, #FF4F4F 100%);
        }
      }
    }
  }
}

.isPhone {
  .base-header {
    .title {
      height: 46px;
      line-height: 46px;
      padding: 0 16px;

      & > i {
        display: block;
        font-size: 24px;
        float: right;
        margin-top: 10px;
      }

      img {
        height: 20px;
        margin-top: 13px;
      }

      a, .logout {
        display: none;
      }

      .icon-orange {
        margin-right: 8px;
        font-size: 24px;
      }
    }

    .links {
      display: none;
    }

    .banner {
      height: 440px;
      background: url('../../deps/public/mobie-background.png') no-repeat center center;
      background-size: cover;
      & > div {
        margin: 10px!important;
        padding-top: 80px!important;
        span {
          font-size: 2rem!important;
        }
      }
      .phone-login {
        position: absolute;
        left: 20px;
        width: 90px;
        height: 24px;
        border-radius: 34px;
        border: 1px solid #FFFFFF;
        font-size: 12px;
        color: #fff;
        line-height: 24px;
        display: block;
        text-align: center;
        top: 400px;
      }
    }

    .phoneMenu {
      position: fixed;
      top: 45px;
      left: 0;
      width: 100%;
      height: calc(100% - 45px);
      background: #fff;
      box-shadow: 4px -2px 10px 0px rgba(169, 169, 169, 0.2);
      z-index: 999;

      & > div {
        .tilte {
          padding: 16px 20px;
          border-bottom: 1px solid #D8D8D8;

          i {
            font-size: 24px;
            float: right;
          }
        }

        .lists {
          background: #ECECEC;

          div {
            padding: 16px 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/baseHeader/index.vue